import { Injectable, inject } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { TradingProcedureResponseDto } from '../schemas/trading-procedure-responses/trading-procedure-response.dto';

@Injectable({ providedIn: 'root' })
export class TradingProcedureApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/tradingProcedure`;

    getAll() {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<TradingProcedureResponseDto[]>()
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<TradingProcedureResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
